import { useState } from 'react';
import React from 'react';
import { useCollapse } from 'react-collapsed';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function TimelineActivity1({ title, children }) {


     const {t} = useTranslation("studentActivities")
        
             const textFormat = (text) =>
                text.split('\n').map((line, index) => (
            
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ));
    


  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();

  // These variables are for the props to be passed between pages
  const location = useLocation();
  console.log ("Timeline1 useLocation: " + JSON.stringify(location));
  const { state } = location;
  const [missionID, setMissionID] = useState(state.mission_id);
  const [language, setLanguage] = useState(state.language);

  return (
    <div>


      <div className='activity-sec' >
				<h2  className='activity-title'>
                {t("timeline.one.title")}
				</h2>
                <div className='activity-content'>
                    
                
                <p className='mission-text'>  {t("timeline.one.subTitle")}</p>

                <button className={`expand-btn ${isExpanded ? 'expand-btn-expanded' : 'expand-btn-collapsed'}`} {...getToggleProps()}>{isExpanded ? t("timeline.one.collapse") : t("timeline.one.expand")}</button>
      <h2>{title}</h2>

      <div {...getCollapseProps()}>{isExpanded && children}
                

                <h3 className='outline-head'> {t("timeline.one.objective.title")}</h3>
                <p className='outline-text'>  {textFormat(t("timeline.one.objective.description"))}
                
                 <a href='https://historicalthinking.ca/historical-thinking-concepts' target='_blank'> 
                 
                  {t("timeline.one.objective.link")}
                  
                   </a> 
                   {textFormat(t("timeline.one.objective.descriptionContinued"))}
                  
                </p>

                <h3 className='outline-head'>  {t("timeline.one.actionSteps.title")} </h3>
                <p className='outline-text'> 
                    <Link to="/timeline" state={{mission_id:missionID, language:language, timeline_filter:1}}> {t("timeline.one.actionSteps.link")}</Link> {t("timeline.one.actionSteps.description")}
                 {textFormat(t("timeline.one.actionSteps.descriptionContinued"))}
                </p>

                <h3 className='outline-head'> {t("timeline.one.questions.title")}</h3>
                <p className='outline-text'> 
                {textFormat(t('timeline.one.questions.description'))} 
                  

                </p>


                <h3 className='outline-head'> {t("timeline.one.debrief.title")}</h3>
                <p className='outline-text'> 


                {t("timeline.one.debrief.description")} <Link to="/mission-control" state={{mission_id:missionID, language:language}}>{t("timeline.one.debrief.link1")}</Link>. <br /> 
	               
                   
                   
                {textFormat(t("timeline.one.debrief.descriptionContinued"))}
                  
                    <ul>
                        <li> <Link to="/mission-control" state={{mission_id:missionID, language:language}}>  {t("timeline.one.debrief.link2")}</Link></li>
                        <li> <Link to="/mission-control" state={{mission_id:missionID, language:language}}>   {t("timeline.one.debrief.link3")}</Link></li>
                    </ul>

                </p>
                
                </div>
                </div>

			</div>
    </div>
  );
}

export default TimelineActivity1;